import http from '../utils/request'

/** 日程安排接口 — 对应后端 ScheduleController (/api/schedule) */

/** 获取首页日程（前后3个月） */
export const getDashboardSchedules = () => http.get('/schedule/dashboard')

/** 获取指定月份日程 */
export const getScheduleList = (year, month) =>
  http.get('/schedule/list', { params: { year, month } })

/** 新增/更新日程 */
export const saveSchedule = (data) => http.post('/schedule', data)

/** 删除日程 */
export const deleteSchedule = (guid) => http.delete(`/schedule/${guid}`)
